import "./contact.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhoneFlip, faLocationPin, faClock } from '@fortawesome/free-solid-svg-icons';
const Contact = () => {
  return (
    <div className="contact__us">
      <h1 className="title">Contact</h1>
      <hr/>
      <h2 className="heading">Stay In Touch</h2>
      <p className="text">We are always on hand to consistently deliver high end manufacturing of furnaces, hyrdualic power systems, extruders and lots more.</p>
    
      <div className="contact_details">
        <div className="content__icon"><span className="icon"><FontAwesomeIcon icon = {faLocationPin}/></span></div>
        <div className="content__text"><span className="contact__title">Office</span><span className="contact__text">100, Ikorodu Road, by Ajegunle Bus Stop, Lagos.</span></div>
      </div>
      <div className="contact_details">
        <div className="content__icon"><span className="icon"><FontAwesomeIcon icon = {faLocationPin}/></span></div>
        <div className="content__text"><span className="contact__title">Warehouses</span><span className="contact__text">1. General Bus Stop, Lagos Abeokuta Express Way, Lagos.</span>
        <span className="contact__text">2. Singer Bus Stop, Lagos Abeokuta Express Way, Ogun State.</span></div>

      </div>
      <div className="contact_details">
        <div className="content__icon"><span className="icon"><FontAwesomeIcon icon = {faPhoneFlip}/></span></div>
        <div className="content__text"><span className="contact__title">Phone</span><span className="contact__text">+2348066816640</span></div>
      </div>
      <div className="contact_details">
        <div className="content__icon"><span className="icon"><FontAwesomeIcon icon = {faEnvelope}/></span></div>
        <div className="content__text"><span className="contact__title">Email</span><span className="contact__text">contact@raydron.com</span></div>
      </div>
      <div className="contact_details">
        <div className="content__icon"><span className="icon"><FontAwesomeIcon icon = {faClock}/></span></div>
        <div className="content__text"><span className="contact__title">Mon - Sat:</span><span className="contact__text">9:00 AM - 5:00 PM</span></div>
      </div>
    </div>
  )
}

export default Contact